module.exports = __webpack_public_path__ + "static/img/chevron-up.63c9165d.svg";